// import { Link } from 'react-router-dom'

const Missing = () => {
	return (
		<article style={{ padding: '100px' }}>
			<h1>
				Page Not Found
			</h1>
		</article>
	)
}

export default Missing